import {ÉvénementsGTM} from "./constantes.js";

export class GestionnaireOnglets {
    constructor() {
        this.conteneur = document.getElementById('recherche');
        if(this.conteneur) {
            this.onglets = this.conteneur.querySelectorAll('.onglet');
            this.panneaux = this.conteneur.querySelectorAll('.panneau-onglet');
            this.attacherÉvénements();
        }
    }

    attacherÉvénements() {
        this.onglets.forEach(onglet => {
            onglet.addEventListener('click', () => this.changerOnglet(onglet));
        });
    }

    changerOnglet(ongletSélectionné) {
        const panneauCible = document.getElementById(ongletSélectionné.dataset.panneau);

        envoyerÉvénementGTM(ÉvénementsGTM.CLIC.code, ÉvénementsGTM.CLIC.actions.MOTS_ONGLET, ongletSélectionné.dataset.panneau);

        this.onglets.forEach(onglet => onglet.classList.remove('onglet-actif'));
        this.panneaux.forEach(panneau => panneau.classList.remove('panneau-onglet-actif'));

        ongletSélectionné.classList.add('onglet-actif');
        panneauCible.classList.add('panneau-onglet-actif');
    }
}
